import { useState } from 'react'
import { ButtonLoader, Input } from 'components/__new/common/form'
import SignupFormHeader from './SignupFormHeader'
import AccountExistsButton from './AccountExistsButton'
import { ReactComponent as IconLeft } from "assets/images/icons/project-icons/arrow-left.svg";
import { ReactComponent as EyeMasked } from "assets/images/icons/project-icons/eye-masked.svg"
import { ReactComponent as EyeRevealed } from "assets/images/icons/project-icons/eye-revealed.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const GetStartedCreatePassword = ({form, formErrors, updateForm, submitForm, setForm, decrementStep, loading}) => {
    
    const LOWER_CASE_REGEX = /(?=.*[a-z])/;
    const UPPER_CASE_REGEX = /(?=.*[A-Z])/;
    const NUMBER_REGEX = /(?=.*[0-9])/;
    const SPECIAL_CHARACTER_REGEX = /[^A-Za-z0-9]/;
    const EIGHT_CHARACTERS_REGEX = /(?=.{8,})/;
    
    const [pwdShown, setPwdShown] = useState(false);
    const [confirmPwdShown, setConfirmPwdShown] = useState(false);
    
    const [lengthValid, setLengthValid] = useState(false);
    const [lowerCaseValid, setLowerCaseValid] = useState(false);
    const [upperCaseValid, setUpperCaseValid] = useState(false);
    const [characterValid, setCharacterValid] = useState(false);
    const [numberValid, setNumberValid] = useState(false);
    
    const passwordProps = [
        {
            text: "Be at least 8 characters in length",
            isValid: lengthValid,
        },
        {
            text: "Contain at least one lower case character",
            isValid: lowerCaseValid
        },
        {
            text: "Contain at least one upper case character",
            isValid: upperCaseValid
        },
        {
            text: "Contain at least one special character",
            isValid: characterValid
        },
        {
            text: "Contain at least one number",
            isValid: numberValid
        }
    ]
    
    const validatePassword = (password) => {
        setForm({...form, password});
        
        if(EIGHT_CHARACTERS_REGEX.test(password)) {
            setLengthValid(true);
        } else {
            setLengthValid(false);
        }
        
        if(LOWER_CASE_REGEX.test(password)) {
            setLowerCaseValid(true);
        } else {
            setLowerCaseValid(false);
        }
        
        if(UPPER_CASE_REGEX.test(password)) {
            setUpperCaseValid(true);
        } else {
            setUpperCaseValid(false);
        }
        
        if(SPECIAL_CHARACTER_REGEX.test(password)) {
            setCharacterValid(true);
        } else {
            setCharacterValid(false);
        }
        
        if(NUMBER_REGEX.test(password)) {
            setNumberValid(true);
        } else {
            setNumberValid(false);
        }
    }
    
    const submitDisabled = !lengthValid || !lowerCaseValid || !upperCaseValid || !characterValid || !numberValid || form?.password !== form?.password_confirmation
    
    return (
        <div>
            
            <SignupFormHeader 
                stepCount="3"
                headerText="Create Password"
                completionPercentage={100}
            />
            
            <button onClick={decrementStep} className='flex items-center mt-5 text-[#0D0C2B]'>
                <span className="mr-1 text-sm"><IconLeft className='text-xs' width={15} /></span>
                Back
            </button>
            
            <form onSubmit={submitForm}>
                <div className="mt-7 w-full max-w-md mx-auto md:mx-0 lg:w-96">
                    
                    <Input
                        label="Password" 
                        autoComplete="off" 
                        placeholder="Enter Password"
                        type={pwdShown ? "text" : "password"} 
                        rightIconClicked={() => setPwdShown(!pwdShown)}
                        rightIcon={<div className='pr-2'>{pwdShown ? <EyeRevealed /> :  <EyeMasked />}</div>}
                        value={form.password} onChange={(e) => validatePassword(e.target.value)} 
                    />
                    
                    <div className="pb-4">
                        {passwordProps.map(({text, isValid}) => (
                            <div key={text} className="w-full mb-1 flex items-center">
                                <span>
                                    <FontAwesomeIcon 
                                        icon={isValid ? "check-circle" : "times-circle"} 
                                        className={`text-sm transition-all duration-200 ${isValid ? "text-green-500" : "text-red-500"}`}
                                        />
                                </span>
                                <p className={`text-sm mb-0 ml-2 transition-colors duration-200 ${isValid ? "text-green-500" : "text-red-500"}`}>
                                    {text}
                                </p>
                            </div>
                        ))}
                    </div>
                    
                    <Input
                        disabled={!lengthValid || !lowerCaseValid || !upperCaseValid || !characterValid || !numberValid}
                        autoComplete="off" 
                        label="Confirm Password" 
                        placeholder="Confirm Password"
                        value={form.password_confirmation} 
                        type={confirmPwdShown ? "text" : "password"} 
                        rightIconClicked={() => setConfirmPwdShown(!confirmPwdShown)}
                        onChange={(e) => updateForm(e, "password_confirmation")} 
                        // rightIcon={<div className='pr-2 pb-2'>{confirmPwdShown ? <EyeRevealed /> :  <EyeMasked />}</div>}
                        tagText={formErrors?.password_confirmation}
                        tagTextIsRed
                    />
                    
                    <ButtonLoader loading={loading} disabled={submitDisabled || loading} type="submit" className="btn btn-lg btn-block btn-ep-primary mt-5 disabled:!bg-[#E2E8F0] disabled:cursor-not-allowed transition-colors duration-300">
                        {loading ? "Initializing" : "Continue"}
                    </ButtonLoader>

                    <AccountExistsButton />
                </div>
            </form>
        </div>
    )
}

export default GetStartedCreatePassword